<!--
 * @Author: 张天昊
 * @Date: 2024-05-21 14:54:56
 * @LastEditTime: 2024-06-17 11:34:02
 * @LastEditors: 张天昊
 * @Description: 基础信息头里面的卡片
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/BasicInfoCard.vue
-->
<script>
import { defineComponent, ref, computed } from 'vue';
import moment from 'moment';
import store from '@/store';

const dateStrFormat = 'YYYY年M月DD日';

const placeStrFormatter = (str) =>
  str
    .split('/')
    .map((item) => item.trim())
    .join(' / ');
export default defineComponent({
  setup() {
    const detailInfo = computed(
      () => store.state.itineraryUniversal.detailInfo.value
    );
    const locations = computed(() => [
      {
        label: '出发地',
        value: placeStrFormatter(
          detailInfo.value.itineraryInfoMessage.teamStartPlaceStr
        )
      },
      {
        label: '目的地',
        value: placeStrFormatter(
          detailInfo.value.itineraryInfoMessage.teamEndPlaceStr
        )
      }
    ]);
    const timestamps = computed(() => [
      {
        label: '出团时间',
        date: moment(
          detailInfo.value.itineraryInfoMessage.teamStartDate
        ).format(dateStrFormat),
        time: moment(
          detailInfo.value.itineraryInfoMessage.teamStartDate
        ).format('HH:mm')
      },
      {
        label: '散团时间',
        date: moment(detailInfo.value.itineraryInfoMessage.teamEndDate).format(
          dateStrFormat
        ),
        time: moment(detailInfo.value.itineraryInfoMessage.teamEndDate).format(
          'HH:mm'
        )
      }
    ]);
    const duration = computed(() => {
      let days = moment(detailInfo.value.itineraryInfoMessage.teamEndDate).diff(
        moment(detailInfo.value.itineraryInfoMessage.teamStartDate),
        'days'
      );
      if (days === 0) {
        days++;
      }
      return days;
    });
    return {
      detailInfo,
      locations,
      timestamps,
      duration
    };
  }
});
</script>

<template>
  <div v-if="detailInfo" class="w-full">
    <div
      class="w-full rounded-tl-4 rounded-tr-4 bg-white px-12 pb-12 pt-16 text-12 leading-20 font-semibold"
    >
      <van-steps
        :active="Number.NEGATIVE_INFINITY"
        class="custom-steps-style-a -my-6"
        direction="vertical"
      >
        <van-step
          v-for="item in locations"
          :key="item.label"
          :style="{ '--custom-step-circle-top': $px2rem(10) }"
          class="custom-step-style-a"
        >
          <template #inactive-icon>
            <div class="custom-step-dot-style-a"></div>
          </template>
          <span class="text-grey-b">{{ item.label }}</span>
          <span class="text-black-a ml-10">{{ item.value }}</span>
        </van-step>
      </van-steps>
    </div>
    <div
      class="relative w-full rounded-bl-4 rounded-br-4 bg-board-a px-12 pt-12 pb-16 flex justify-between"
    >
      <div
        v-for="(item, index) in timestamps"
        :key="item.label"
        :class="index === 1 ? 'text-right' : 'text-left'"
        class="leading-20"
      >
        <div class="text-12 text-grey-a">{{ item.label }}</div>
        <div class="text-16 font-semibold mt-4">{{ item.date }}</div>
        <div class="text-0 leading-22 mt-2">
          <svg-icon
            pre-path="itineraryUniversal"
            name="ic-clock-line"
            class="w-16 h-16 mr-3 align-middle"
          /><span class="align-middle text-16">{{ item.time }}</span>
        </div>
      </div>
      <div
        class="absolute z-1 flex items-center top-40 left-1/2 -translate-x-1/2 text-grey-a text-12 leading-none"
      >
        <span class="wrap-arrow">共{{ duration }}天<i /></span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.wrap-arrow {
  position: relative;
  padding: 0 16px;
}
.wrap-arrow::before,
.wrap-arrow::after {
  position: absolute;
  content: '';
  width: 10px;
  height: 1.2px;
  background: currentColor;
  border-radius: 2px;
  top: 50%;
  transform: translateY(-50%);
}
.wrap-arrow::before {
  left: 0;
}
.wrap-arrow::after {
  right: 0;
}
.wrap-arrow > i {
  position: absolute;
  content: '';
  width: 5px;
  height: 1.2px;
  background: currentColor;
  border-radius: 2px;
  right: 0;
  top: 50%;
  transform-origin: center right;
  transform: translateY(-50%) rotate(45deg);
}
</style>
